import React from "react";
import styles from "./App.module.css";

import Routes from "./router/Routes";
import { Router } from "react-router-dom";
import history from "./core/helper/Helper";

import { MenuList } from "./components/Menu";
import Footer from "./components/Footer";
import ScrollTop from "./components/ScrollTop";
import { Provider } from "react-redux";
import store from "redux/store";
import Progress from "shared/components/Progress";
import { ToastContainer } from "react-toastify";
import Fabs from "components/Fabs";

function App() {
  return (
    <Provider store={store}>
      <div className={styles.wrapper}>
        <header id="header">
          <ToastContainer />
          <Progress />
          <MenuList />
        </header>

        <article id={styles.content_main}>
          <Router history={history}>
            <Routes />
          </Router>
          <a href="#header">
            <ScrollTop />
          </a>

          <Fabs />
        </article>

        <footer id="header">
          <Footer />
        </footer>
      </div>
    </Provider>
  );
}

export default App;
